var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kircWrapper", attrs: { id: "kirc" } }, [
    _c("div", { staticClass: "particles" }),
    _vm._v(" "),
    _c("div", { staticClass: "md-layout md-alignment-top-center" }, [
      _c(
        "div",
        {
          staticClass:
            "\n                          md-layout-item\n                          md-size-80\n                          md-medium-size-95\n                          md-small-size-95\n                          md-xsmall-size-100\n                        "
        },
        [
          !_vm.showComparison()
            ? _c(
                "md-card",
                [
                  _c("md-card-content", [
                    _c(
                      "div",
                      {
                        staticClass: "md-layout",
                        class: "md-alignment-top-center"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100",
                            class: "md-alignment-top-center"
                          },
                          [
                            _c("div", { staticClass: "headlineWrapper" }, [
                              _c(
                                "div",
                                { staticClass: "md-display-1 mainHeadline" },
                                [
                                  _vm._v(
                                    "\n                  Hier alten Ergebniscode eingeben:\n                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "md-field",
                              [
                                _c("label", [
                                  _vm._v("KI-Readiness-Check Ergebniscode")
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  model: {
                                    value: _vm.oldHash,
                                    callback: function($$v) {
                                      _vm.oldHash = $$v
                                    },
                                    expression: "oldHash"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-actions",
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-raised md-primary CTA CTA--Main",
                          attrs: { to: "" },
                          on: {
                            click: function($event) {
                              return _vm.loadKIRCData()
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "buttonText" }, [
                            _vm._v("Ergebnis laden")
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.error === "new"
                    ? _c("h4", [
                        _vm._v(
                          "\n          Der Ergebniscode in Ihrem Link ist ungültig. Bitte führen Sie den KIRC erneut durch.\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.error === "old"
                    ? _c("h4", [
                        _vm._v(
                          "\n          Dieser Ergebniscode ist uns nicht bekannt. Bitte geben Sie einen gültigen Ergebniscode an.\n        "
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showComparison()
            ? _c(
                "md-card",
                {
                  staticClass: "mainFormCard md-elevation-16",
                  staticStyle: { "max-width": "70%" }
                },
                [
                  _c("md-card-header", [
                    _c("div", { staticClass: "headlineWrapper" }, [
                      _c("div", { staticClass: "md-layout" }, [
                        _c(
                          "div",
                          { staticClass: "md-layout-item md-size-50" },
                          [
                            _c(
                              "div",
                              { staticClass: "md-display-2 mainHeadline" },
                              [
                                _vm._v(
                                  "\n                  Neuer KIRC\n                "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-size-50",
                            attrs: { align: "right" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "md-display-2 mainHeadline" },
                              [
                                _vm._v(
                                  "\n                  Alter KIRC\n                "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-content",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-evenly"
                          }
                        },
                        [
                          _c(
                            "md-card",
                            { staticClass: "CustomCard" },
                            [
                              _c("md-card-content", [
                                _c(
                                  "div",
                                  { staticStyle: { position: "relative" } },
                                  [
                                    _c("md-progress-spinner", {
                                      attrs: {
                                        align: "center",
                                        "md-diameter": 250,
                                        "md-stroke": 30,
                                        "md-mode": "determinate",
                                        "md-value":
                                          _vm.newData.score *
                                          0.2967359050445103857566765578635
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "finalScoreWrapper" },
                                      [
                                        _c(
                                          "h4",
                                          { staticClass: "levelSubheading" },
                                          [_vm._v("Level")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h1",
                                          {
                                            staticClass: "mb-2",
                                            attrs: { id: "finalScore" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  Math.ceil(
                                                    _vm.newData.score / 68
                                                  ) + "/5"
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        Math.ceil(_vm.newData.score / 68) === 1
                                          ? _c(
                                              "h1",
                                              {
                                                attrs: {
                                                  slot: "textCard__Headline"
                                                },
                                                slot: "textCard__Headline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.level1.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        Math.ceil(_vm.newData.score / 68) === 2
                                          ? _c(
                                              "h1",
                                              {
                                                attrs: {
                                                  slot: "textCard__Headline"
                                                },
                                                slot: "textCard__Headline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.level2.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        Math.ceil(_vm.newData.score / 68) === 3
                                          ? _c(
                                              "h1",
                                              {
                                                attrs: {
                                                  slot: "textCard__Headline"
                                                },
                                                slot: "textCard__Headline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.level3.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        Math.ceil(_vm.newData.score / 68) === 4
                                          ? _c(
                                              "h1",
                                              {
                                                attrs: {
                                                  slot: "textCard__Headline"
                                                },
                                                slot: "textCard__Headline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.level4.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        Math.ceil(_vm.newData.score / 68) === 5
                                          ? _c(
                                              "h1",
                                              {
                                                attrs: {
                                                  slot: "textCard__Headline"
                                                },
                                                slot: "textCard__Headline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.level5.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "md-card",
                            { staticClass: "CustomCard" },
                            [
                              _c("md-card-content", [
                                _c(
                                  "div",
                                  { staticStyle: { position: "relative" } },
                                  [
                                    _c("md-progress-spinner", {
                                      attrs: {
                                        align: "center",
                                        "md-diameter": 250,
                                        "md-stroke": 30,
                                        "md-mode": "determinate",
                                        "md-value":
                                          _vm.oldData.score *
                                          0.2967359050445103857566765578635
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "finalScoreWrapper" },
                                      [
                                        _c(
                                          "h4",
                                          { staticClass: "levelSubheading" },
                                          [_vm._v("Level")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h1",
                                          {
                                            staticClass: "mb-2",
                                            attrs: { id: "finalScore" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  Math.ceil(
                                                    _vm.oldData.score / 68
                                                  ) + "/5"
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        Math.ceil(_vm.oldData.score / 68) === 1
                                          ? _c(
                                              "h1",
                                              {
                                                attrs: {
                                                  slot: "textCard__Headline"
                                                },
                                                slot: "textCard__Headline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.level1.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        Math.ceil(_vm.oldData.score / 68) === 2
                                          ? _c(
                                              "h1",
                                              {
                                                attrs: {
                                                  slot: "textCard__Headline"
                                                },
                                                slot: "textCard__Headline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.level2.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        Math.ceil(_vm.oldData.score / 68) === 3
                                          ? _c(
                                              "h1",
                                              {
                                                attrs: {
                                                  slot: "textCard__Headline"
                                                },
                                                slot: "textCard__Headline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.level3.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        Math.ceil(_vm.oldData.score / 68) === 4
                                          ? _c(
                                              "h1",
                                              {
                                                attrs: {
                                                  slot: "textCard__Headline"
                                                },
                                                slot: "textCard__Headline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.level4.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        Math.ceil(_vm.oldData.score / 68) === 5
                                          ? _c(
                                              "h1",
                                              {
                                                attrs: {
                                                  slot: "textCard__Headline"
                                                },
                                                slot: "textCard__Headline"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.level5.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-list",
                        _vm._l(_vm.kirc, function(item, key) {
                          return _c(
                            "div",
                            { key: key },
                            [
                              _c(
                                "md-subheader",
                                { staticClass: "md-primary md-title" },
                                [_vm._v(_vm._s(key))]
                              ),
                              _vm._v(" "),
                              _vm._l(item, function(question, index) {
                                return _c("div", { key: question.name }, [
                                  !question.optional
                                    ? _c("div", [
                                        _c(
                                          "h4",
                                          { staticClass: "singleQuestion" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  question.newidx +
                                                    ". " +
                                                    question.name
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "space-between"
                                            }
                                          },
                                          [
                                            !question.newAnswer
                                              ? _c("p", [_vm._v("N/A")])
                                              : !question.oldAnswer
                                              ? _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      question.newAnswer.text
                                                    )
                                                  )
                                                ])
                                              : question.newAnswer.text !=
                                                question.oldAnswer.text
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      color: "green",
                                                      "font-weight": "bold"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        question.newAnswer.text
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      question.newAnswer.text
                                                    )
                                                  )
                                                ]),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "margin-right": "20px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    question.oldAnswer
                                                      ? question.oldAnswer.text
                                                      : "N/A"
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              })
                            ],
                            2
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1f2afa4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1f2afa4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/compare/kirccompare.vue
// module id = null
// module chunks = 